import { apiClient } from "@/api/axios";
import type { ApiResponse } from "@/types/api";
import type { DashboardData } from "@/types/dashboard";

export async function GetDashboard() {
  const { data } = await apiClient.post<ApiResponse<DashboardData>>(
    "/api/v1/dashboard/get_dashboard",
  );

  if (!data.status) {
    throw new Error(data.message ?? "Failed to fetch dashboard data");
  }

  return data;
}